import React from 'react';

import Sceleton from '../skeleton';

import TCell from './cell';

export default function THeader(props) {
  const { columns, numberOfcolumns = 0 } = props;

  if (!columns?.length) {
    return [...Array(numberOfcolumns)].map((_, i) => {
      return (
        <TCell key={i}>
          <Sceleton />
        </TCell>
      );
    });
  }

  return columns?.map((el, key) => {
    if (!el.column) {
      return <TCell key={`${key}`} />;
    }

    return (
      <TCell {...el} key={`${key}-${el.column}`}>
        {el.title ?? null}
      </TCell>
    );
  });
}
